import Vue from 'vue';

Vue.component('fnb-stock-receive-index', () =>
    import(/* webpackChunkName: 'fnb-stock-receive-index' */ './stock-receive-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory-fnb/stock-receive/index.js